module.exports = __webpack_public_path__ + "static/media/syn-simi-appid-1920x1080.a80ca270.jpg";